import { createFileRoute } from "@tanstack/react-router";
import { BreadcrumbHeader } from "@/components/primitives/breadcrumb-header";
import {
  Article,
  ArticleBody,
  ArticleContainer,
  ArticleDescription,
  ArticleHeader,
  ArticleHeading,
  ArticleRelatedLink,
  ArticleSection,
} from "@/components/primitives/article";
import { PageContainer } from "@/components/primitives/layout";
import { SingleBreadcrumb } from "@/components/primitives/single-breadcrumb";
import { FaqItems } from "@/components/views/faq/faq-items";
import { FAQ_SECTIONS } from "@/components/views/faq/faq-data";

const TITLE = "Frequently asked questions";
const DESCRIPTION =
  "Answers to common questions about Scoopulator and ice cream science.";

const FAQ_STRUCTURED_DATA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ_SECTIONS.flatMap((section) =>
    section.items.map((item) => ({
      "@type": "Question" as const,
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer" as const,
        text: item.answer,
      },
    })),
  ),
};

export const Route = createFileRoute("/learn/faq")({
  head: () => ({
    meta: [
      { title: `${TITLE} - Scoopulator` },
      { name: "description", content: DESCRIPTION },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(FAQ_STRUCTURED_DATA),
      },
    ],
  }),
  component: FaqPage,
});

function FaqPage() {
  return (
    <PageContainer>
      <ArticleContainer>
        <BreadcrumbHeader>
          <SingleBreadcrumb href="/learn" label="Learn more about ice cream" />
        </BreadcrumbHeader>

        <Article>
          <ArticleHeader>
            <ArticleHeading>{TITLE}</ArticleHeading>
            <ArticleDescription>{DESCRIPTION}</ArticleDescription>
          </ArticleHeader>

          <ArticleBody>
            <ArticleSection>
              <FaqItems />
            </ArticleSection>

            <ArticleSection>
              <ArticleRelatedLink
                href="/calc"
                title="Try Scoopulator's free ice cream calculator"
                label="Get started"
                srLabel="Ice cream calculator"
                description="Build a recipe, hit your targets, and iterate with confidence."
              />
            </ArticleSection>
          </ArticleBody>
        </Article>
      </ArticleContainer>
    </PageContainer>
  );
}
